import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=b6958310&scoped=true&"
import script from "./BaseSearch.vue?vue&type=script&lang=js&"
export * from "./BaseSearch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearch.vue?vue&type=style&index=0&id=b6958310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6958310",
  null
  
)

export default component.exports